export default __webpack_public_path__ + "static/media/mini-icon-analytics-active.728fc10a.svg";